import { useState, useEffect } from 'react';
import { supabase } from './supabase';

export function useRatings(activityId) {
  const [avg, setAvg]         = useState(null);
  const [count, setCount]     = useState(0);
  const [myScore, setMyScore] = useState(null);
  const [loading, setLoading] = useState(true);

  const storageKey = 'kidzmap_rated_' + activityId;

  useEffect(() => {
    if (!activityId) return;

    // Check localStorage for previous rating
    const saved = localStorage.getItem(storageKey);
    if (saved) setMyScore(parseInt(saved, 10));

    // Fetch ratings from Supabase
    async function fetchRatings() {
      try {
        const { data, error } = await supabase
          .from('ratings')
          .select('score')
          .eq('activity_id', activityId);

        if (error || !data || data.length === 0) {
          setAvg(null);
          setCount(0);
        } else {
          const sum = data.reduce((acc, r) => acc + r.score, 0);
          setAvg(Math.round((sum / data.length) * 10) / 10);
          setCount(data.length);
        }
      } catch {
        setAvg(null);
        setCount(0);
      } finally {
        setLoading(false);
      }
    }

    fetchRatings();
  }, [activityId, storageKey]);

  async function submitRating(score) {
    if (score < 1 || score > 5) return { ok: false };

    try {
      const { error } = await supabase
        .from('ratings')
        .insert({ activity_id: activityId, score });

      if (error) return { ok: false };

      localStorage.setItem(storageKey, String(score));
      setMyScore(score);

      // Optimistically update avg
      const newCount = count + 1;
      const newSum   = (avg || 0) * count + score;
      setAvg(Math.round((newSum / newCount) * 10) / 10);
      setCount(newCount);

      return { ok: true };
    } catch {
      return { ok: false };
    }
  }

  return { avg, count, myScore, loading, submitRating };
}